import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import queryString from 'query-string'
import { CloseIcon } from 'components/icons'
import { registryHomePath } from 'lib/urls'
import css from './guide-viewer.scss'

class GuideViewer extends PureComponent {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  state = {
    scrollY: null,
  }

  componentDidMount() {
    this.onEnterFullScreen()
  }

  componentWillUnmount() {
    this.onExitFullscreen()
  }

  handleClose() {
    const { history } = this.props
    history.replace(registryHomePath)
  }

  onEnterFullScreen = () => {
    // prevents background from scrolling while guide is open
    setTimeout(() => {
      this.setState({ scrollY: window.scrollY })
      if (document && document.body) {
        document.body.className += document.body.className.length
          ? ' modal-open-fullscreen'
          : 'modal-open-fullscreen'
      }
    }, 500)
  }

  onExitFullscreen = () => {
    if (document && document.body) {
      document.body.className = document.body.className.replace(
        / ?modal-open-fullscreen/,
        ''
      )
    }
    if (this.state.scrollY > 0) {
      window.scrollTo(window.scrollX, this.state.scrollY)
      this.setState({ scrollY: null })
    }
  }

  render() {
    const { location } = this.props
    const params = queryString.parse(location.search)
    return (
      <>
        {!!params && !!params.url && (
          <>
            <div className="modal-backdrop" onClick={this.handleClose} />

            <div className={classNames(css.wrapper)}>
              <button
                className={classNames(
                  css.closeBtn,
                  'animated slideInUp animate-500ms'
                )}
                type="button"
                onClick={this.handleClose}
              >
                <span aria-hidden="true">
                  <CloseIcon />
                </span>
                <span className="sr-only">Close</span>
              </button>
              <iframe
                border="0"
                className={classNames(css.iframe, 'animated nudgeInUp')}
                height="100%"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                src={params.url}
                width="100%"
              />
            </div>
          </>
        )}
      </>
    )
  }
}

export default GuideViewer
